<script lang="ts">

    export let props: boolean = true; // with margin

</script>
    
<style lang="scss">

    .line {
        height: 50px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        &__insideleft {
            border: 2px solid $color_primary;
            border-radius: 20px 0 0 20px;
            width: 50px;
            transition: all 0.5s;
            background-color: $color_primary;
        }
        &__insideright {
            border: 2px solid $color_primary;
            border-radius: 0 20px 20px 0;
            width: 50px;
            transition: all 0.5s;
            background-color: $color_primary;
        }
    }

    @include large {
        .line {
            &__margin {
                padding-top: 150px;
                margin-bottom: -150px;
                transform: translateY(-150px);
            }
            &:hover .line__insideright{
                border: 2px solid $color_orange;
                transform: translateX(50px) scaleX(0.5);
                background-color: $color_orange;
            }
            &:hover .line__insideleft{
                border: 2px solid $color_orange;
                transform: translateX(-50px) scaleX(0.5);
                background-color: $color_orange;
            }
        }
    }

</style>

<div class="line" class:line__margin={props}>
    <div class="line__insideleft"></div>
    <div class="line__insideright"></div>
</div>